import React, { useEffect, useState } from 'react'
import s from './SelectProfessional.module.scss'
import Card from './Card'
import useGetServicesTeamsByServiceId from 'sdk/hooks/booking/useGetServicesTeamsByServiceId'
import Button from 'components/shared/Button'
import { useTranslation } from 'react-i18next'

const SelectProfessional = ({ selectedService, selectedId, handleChoose, handleNext }: any) => {
    const {t} = useTranslation() as any

    // Extract service ID from the selectedService array
    // Handle both cases: receiving full object or just ID
    const getServiceId = () => {
        if (!selectedService || selectedService.length === 0) return null;

        const firstService = selectedService[0];

        // If it's already a primitive (string/number), return it
        if (typeof firstService === 'string' || typeof firstService === 'number') {
            return firstService;
        }

        // If it's an object, try to extract the service ID
        // Check common property names for service ID
        return firstService?.service || firstService?.id || null;
    };

    const serviceId = getServiceId();

    const { data: professionals, refetch } = useGetServicesTeamsByServiceId(serviceId ? [serviceId] : null)

    useEffect(() => {
        if (serviceId) {
            refetch()
        }
    }, [serviceId, selectedService])

    const uniqueProfessionals = professionals?.filter((item, index, self) =>
        index === self.findIndex((t) => t.teams.id === item?.teams.id)
    );

    return (
        <div className={s.select_prof}>
            <div className={s.select_prof_title}>
                {t("Select the professional for")} <span style={{ color: '#C555B4' }}>{professionals?.[0]?.service?.name}</span>
            </div>

            <div className={s.select_cards}>
                {uniqueProfessionals?.map((item) => {
                    return (
                        <Card
                            key={item?.id}
                            id={item?.teams?.id}
                            avatar={item?.teams?.avatar}
                            fullName={item?.teams?.full_name}
                            selectedId={selectedId}
                            handleChoose={handleChoose}
                        />
                    )
                })}

                {uniqueProfessionals?.length === 0 ? <>{t('There is no one right now available to do the services')}</> : "" }
            </div>
            <div className={s.select_prof_action}>
                <Button
                    className={s.select_button}
                    wide
                    darkGreen
                    disabled={!selectedId}
                    onClick={handleNext}
                >
                    {t('Book now')}
                </Button>
            </div>
        </div>
    )
}

export default SelectProfessional